import { useEffect, useState, type CSSProperties } from "react";

/** Full-screen overlay mode with Esc-to-exit (U14). Returns the toggle state
 *  and the style to spread on the container when active. */
export function useFullscreen(): {
  full: boolean;
  setFull: (v: boolean | ((f: boolean) => boolean)) => void;
  overlayStyle: CSSProperties | undefined;
} {
  const [full, setFull] = useState(false);
  useEffect(() => {
    if (!full) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setFull(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [full]);
  const overlayStyle: CSSProperties | undefined = full
    ? {
        position: "fixed", inset: 12, zIndex: 1000, background: "var(--surface)",
        border: "1px solid var(--line2)", borderRadius: 14, padding: 14,
        boxShadow: "0 8px 40px rgba(0,0,0,.35)", display: "flex", flexDirection: "column",
      }
    : undefined;
  return { full, setFull, overlayStyle };
}
